<template>
  <v-layout align-start>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="grupoL"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Asigna Beneficios a Grupos</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Busqueda"
              single-line
              hide-details
            >
            </v-text-field>
            <v-spacer></v-spacer>

            <!--/////////////*****/ DIALOG  -->
            <v-dialog
              v-model="dialog"
              fullscreen
              hide-overlay
              transition="dialog-bottom-transition"
            >
              <!-- <template v-slot:activator="{ on }">
                            <v-btn color="primary" 
                                dark v-on="on" 
                                @click="newItem"
                                outlined>Asignar grupo</v-btn>
                        </template> -->
              <v-card>
                <v-toolbar dark color="primary">
                  <v-btn icon dark @click="dialog = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                  <v-toolbar-title
                    ><span class="headline"
                      >Asignar beneficios</span
                    ></v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                  <!-- <v-btn class="ma-2" @click="Limpiar()" outlined color="indigo">Limpiar Controles</v-btn> -->
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn @click="saveChange" dark text>
                      Grabar
                    </v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <v-card flat>
                  <v-card-text>
                    <h2>{{ TituloNombre }}</h2>
                  </v-card-text>
                </v-card>

                <v-list three-line subheader>
                  <!-- <v-subheader><strong> Seleccione Tipo de grupo</strong></v-subheader> -->
                  <v-container fluid>
                    <v-row>
                      <v-col cols="8" sm="8" md="8">
                        <template>
                          <v-simple-table fixed-header>
                            <thead>
                              <tr>
                                <th class="text-left">Prestacion</th>
                                <th class="text-left">Asignar</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(item, index) in catPrestacion"
                                :key="index"
                              >
                                <td>{{ item.descripcion }}</td>
                                <td>
                                  <v-container fluid @click="selectPrestacionI(item)">
                                    <v-checkbox
                                      v-model="item.vigencia"
                                      :value="item.vigencia"
                                    >
                                    </v-checkbox>
                                  </v-container>
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </template>
                      </v-col>

                      <v-col cols="4" sm="4" md="4">
                        <template>
                          <v-simple-table fixed-header>
                            <thead>
                              <tr>
                                <th class="text-left">Prestacion</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(item, index) in selectPrestacion"
                                :key="index">
                                <td>{{ item.descripcion }}</td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </template>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-list>
              </v-card>
              <v-divider></v-divider>
            </v-dialog>
            <!--/////////////*****/END DIALOG  -->

          </v-toolbar>


        </template>
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="(item, index) in items" :key="index">
              <td>
                <div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on">
                        <v-icon small class="mr-2" @click="select(item)">
                          pan_tool
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Seleccionar</span>
                  </v-tooltip>
                </div>
              </td>
              <td>{{ item.nombre }}</td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  created() {
    this.listar();
  },
  data() {
    return {
         grupoL: [],
         selectGrupo:[],
         TituloNombre: "",
         catPrestacion: [],
    //   selectArea: {},
         selectPrestacion: [],
         dialog: false,
      consultaDto: {
        Skip: 0,
        Take: 100,
        descending: true,
        sortBy: "",
        search: "",
        idUsuario: 0,
        extraParam: "",
      },
      headers: [
        { text: "Opciones", value: "opciones", sortable: false },
        { text: "Beneficio", value: "nombre", sortable: false },
      ],
      search: "",
      snackbar: false,
      snackbarcolor: "",
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    listar() {
      debugger
      let me = this
            me.$store.dispatch('setIsBusy', true)
            me.$axios.get('api/Grupos/Get')
                .then(r => {
                    if (r.data.exito) {
                        me.grupoL = r.data.datos
                    }
                   me.$store.dispatch('setIsBusy', false);
                })
                .catch(e => { console.log(e) })
    },
    select(item) {
      let ctx = this;
      ctx.selectGrupo = item;
      ctx.TituloNombre = item.nombre;
      ctx.consultaDto.extraParam = item.idGrupo.toString();
      debugger;
      ctx.$store.dispatch('setIsBusy', true);
      ctx.$axios
        .post("api/PrestacionGrupo/Get", ctx.consultaDto)
        .then((r) => {
          if (r.data.exito) {
              ctx.catPrestacion = [];
              ctx.selectPrestacion = [];
              ctx.catPrestacion = r.data.datos;
              ctx.catPrestacion.forEach((element) => {
                if (
                  element.idGrupo == item.idGrupo &&
                  element.vigencia == true
                ) {
                  ctx.selectPrestacion.push(element);
                }
              });
          }
           ctx.$store.dispatch('setIsBusy', false);
        })
        .catch((e) => {
          console.log(e);
        });
      this.dialog = true;
    },
    saveChange() {
      let ctx = this;

      debugger;
      ctx.$store.dispatch('setIsBusy', true);
      
      var js = {
        "prestaciongrupo": ctx.selectPrestacion,
        "idGrupo": ctx.selectGrupo.idGrupo
      };

      ctx.$axios
        .post("api/PrestacionGrupo/Save", js)
        .then((r) => {
          if (r.data.exito) {
             ctx.$root.Mensaje(r.data.mensaje)
          }
          ctx.$store.dispatch('setIsBusy', false);
        })
        .catch((e) => {
          ctx.$store.dispatch('setIsBusy', false);
          ctx.$root.Mensaje("Ha ocurrido un imprevisto, intentelo nuevamente")
          console.log(e);
        });

      this.dialog = false;
    },
    selectPrestacionI(item) {
      debugger;
      let ctx = this;
      item.idGrupo = ctx.selectGrupo.idGrupo
      var elemento = ctx.selectPrestacion.find((d) => d.idCatPrestacion == item.idCatPrestacion);
      if (elemento === undefined && item.vigencia == true) {
        ctx.selectPrestacion.push(item);
      } else if (elemento.vigencia == false || elemento.vigencia == null) {
        var index = ctx.selectPrestacion.indexOf(elemento);
        ctx.selectPrestacion.splice(index, 1);
        // ctx.selectUsers.r(elemento);
      }
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
  },
};
</script>
